module.exports = __webpack_public_path__ + "b6495cb70be37cb6163edefad107f535.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/savannah.png
// module id = 3181
// module chunks = 0